<template>
  <div ref="dialog">
    <v-card-text>
      <div style="display: flex;">
        <v-text-field
          data-qa="dialog_simple__edit_name_input"
          v-model="dialogConfig.resource.coreResource.name"
          :label="translate('dialog_input_resource_name')"
          required
          ref="resourceName"
          style="margin-top: 7px;"
          outlined
          dense
          background-color="white"
        ></v-text-field>
      </div>

      <div v-if="showAssumptions">
        <TemplateDialogFlow
          :flow="dialogConfig.resource.flows[0]"
          :flowIndex=0
          :updateAssumptions="updateAssumptions"
          :dialogConfig="dialogConfig"
          :dialogFormula="dialogFormula"
          :formulasAvailable="[]"
          :hideUnits="true"
        />
      </div>
    </v-card-text>

    <TemplateDialogHintAssumptions
      :showTooltip="showTooltip"
      @closeDialogHintAssumptions="closeDialogHintAssumptions"
    />

  </div>
</template>

<script>

import TemplateDialogHintAssumptions from './DialogResourceAddHintAssumptions.vue';
import TemplateDialogFlow from './DialogResourceAddFlow.vue';

// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {
    TemplateDialogHintAssumptions,
    TemplateDialogFlow,
  },
  props: {
    cancel: Function,
    save: Function,
    dialogConfig: Object,
    formulas: Array,
    dialogAssumptions: Array,
  },
  mixins: [Mixin],
  data() {
    return {
      radioGroupItems: ['Equity', 'Loan'],
      dialogFormula: {},
      e1: 1,
      showTooltip: false,
    };
  },
  mounted() {
    this.selectFirstInput();
  },
  methods: {
    updateAssumptions(flowIndex, assumptionIndex, value) {
      this.onAssumptionsChange(flowIndex, assumptionIndex, value);
    },
    closeDialogHintAssumptions() {
      this.showTooltip = false;
    },
    onCancel() {
      this.cancel();
    },
    onSave() {
      this.save();
    },
    updateFlowAssumptions(value, index) {
      const flowIndex = 0;
      this.onAssumptionsChange(flowIndex, value, index);
    },
  },
  computed: {
    showAssumptions() {
      const isCurrency = this.dialogConfig.resource.coreResource.rel === 'currency';
      const hasFormula = this.dialogConfig.resource.flows[0].formula;
      return !isCurrency && hasFormula;
    },
  },
};
</script>
